/* ===========================================================
   APPLE × EMAAR — Unified Scroll Reveal Engine
   Cleaned + optimized + single event listener
=========================================================== */

document.addEventListener("DOMContentLoaded", () => {

  const revealItems = document.querySelectorAll(".reveal");
  const staggerParents = document.querySelectorAll(".stagger-parent");

  function activateOnScroll() {
    const triggerPoint = window.innerHeight - 80;

    revealItems.forEach(el => {
      if (el.getBoundingClientRect().top < triggerPoint) {
        el.classList.add("active");
      }
    });

    staggerParents.forEach(parent => {
      if (parent.getBoundingClientRect().top < triggerPoint) {
        parent.classList.add("active");
      }
    });
  }

  activateOnScroll();
  window.addEventListener("scroll", activateOnScroll);
});
